import {
  combinationTrim,
  dbToLinear,
  masterSafetyTrim,
  trackGainDb,
} from '@eternally/core';

/**
 * The facts the engine needs per track, straight from the viewer
 * manifest: measured numbers only, no topology.
 */
export interface PlanTrack {
  id: string;
  lufs: number;
  truePeakDb: number;
}

export interface GainPlan {
  /** Linear gain per track id: makeup gain when active, zero otherwise. */
  trackGains: Map<string, number>;
  /** Linear master gain: combination trim times headroom safety trim. */
  masterGain: number;
}

/**
 * Pure mapping from "which tracks are active" to every gain value in
 * the graph. The engine applies plans, it never computes levels; that
 * keeps the mathematics testable without a single Web Audio node.
 */
export function computeGainPlan(
  tracks: readonly PlanTrack[],
  activeIds: ReadonlySet<string>,
  targetLufs: number,
): GainPlan {
  const active = tracks.filter((track) => activeIds.has(track.id));
  const trackGains = new Map<string, number>();
  for (const track of tracks) {
    trackGains.set(
      track.id,
      activeIds.has(track.id) ? dbToLinear(trackGainDb(track, targetLufs)) : 0,
    );
  }
  return {
    trackGains,
    masterGain: combinationTrim(active) * masterSafetyTrim(active, targetLufs),
  };
}
